import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SuperPlatformAI } from './pages/SuperPlatformAI';
import { QuasarPlatform } from './pages/QuasarPlatform';
import { UDSAPlatform } from './pages/UDSAPlatform';
export function AppRouter() {
  return <BrowserRouter data-id="element-138">
      <Routes data-id="element-139">
        <Route path="/" element={<App data-id="element-141" />} data-id="element-140" />
        <Route path="/super-platform-ai" element={<SuperPlatformAI data-id="element-143" />} data-id="element-142" />
        <Route path="/quasar" element={<QuasarPlatform data-id="element-145" />} data-id="element-144" />
        <Route path="/udsa" element={<UDSAPlatform data-id="element-147" />} data-id="element-146" />
      </Routes>
    </BrowserRouter>;
}